module.exports = __webpack_public_path__ + "static/media/3154.94d2b0df.jpg";